module.exports = __webpack_public_path__ + "SP_SPT8-Doctor-e849ef342f3bd2dfe6ee3a5917b5de43.png";